import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import SEO from '../../components/seo';
import PageHeader from '../../components/pageHeader';
import Tabs from '../../components/tab';
import Style from './style.module.scss';

const KvkPolicy = () => {
  const { t, i18n } = useTranslation();

  const clarificationParagraphs = t('kvkPage.clarification.paragraphs', { returnObjects: true });
  const privacyParagraphs = t('kvkPage.kvk.paragraphs', { returnObjects: true });

  const applicationForm =
    i18n.language === 'tr'
      ? './assets/docs/KVKK-Basvuru-Formu.docx'
      : './assets/docs/KVKK-Request-Form.docx';

  const tabs = [
    {
      key: 'informationTabTitle',
      label: t('informationTabTitle'),
      content: (
        <div className={Style.container}>
          <div className={Style.policyWrapper}>
            <div className={Style.policyLine}>
              <h2 className={Style.lineTitle}>{t('kvkPage.clarification.title')}</h2>
              <div>
                <p
                  className={Style.lineText}
                  dangerouslySetInnerHTML={{ __html: t('kvkPage.clarification.dataResponsible') }}
                />
                <p
                  className={Style.lineText}
                  dangerouslySetInnerHTML={{ __html: t('kvkPage.clarification.address') }}
                />
                <p
                  className={Style.lineText}
                  dangerouslySetInnerHTML={{ __html: t('kvkPage.clarification.headText') }}
                />
              </div>
            </div>
            {Object.values(clarificationParagraphs).map((text, index) => (
              <div className={Style.policyLine} key={index}>
                {text.title && <h2 className={Style.lineTitle}>{t(text.title)}</h2>}

                {text.subtitle && (
                  <p
                    className={Style.lineText}
                    dangerouslySetInnerHTML={{
                      __html: t(text.subtitle),
                    }}
                  />
                )}

                {text.paragraphList && (
                  <ul
                    key={index}
                    className={Style.lineText}
                    dangerouslySetInnerHTML={{
                      __html: t(text.paragraphList),
                    }}
                  />
                )}

                {text.paragraph && (
                  <p
                    className={Style.lineText}
                    dangerouslySetInnerHTML={{
                      __html: t(text.paragraph),
                    }}
                  />
                )}
              </div>
            ))}
            <div className={Style.policyLine}>
              <p className={Style.lineText}>
                <Trans
                  i18nKey="kvkPage.kvk.downloadForm"
                  components={[
                    <a key={0} href={applicationForm} target="_blank" rel="noreferrer">
                      {0}
                    </a>,
                    <b key={1}>{1}</b>,
                  ]}
                />
              </p>
            </div>
          </div>
        </div>
      ),
    },
    {
      key: 'kvkkTabTitle',
      label: t('kvkkTabTitle'),
      content: (
        <div className={Style.container}>
          <div className={Style.policyWrapper}>
            <div className={Style.policyLine}>
              <h2
                className={Style.lineTitle}
                dangerouslySetInnerHTML={{ __html: t('kvkPage.kvk.title') }}
              />
              <div>
                <p
                  className={Style.lineText}
                  dangerouslySetInnerHTML={{ __html: t('kvkPage.kvk.dataResponsible') }}
                />
                <p
                  className={Style.lineText}
                  dangerouslySetInnerHTML={{ __html: t('kvkPage.kvk.headText') }}
                />
              </div>
            </div>
            {Object.values(privacyParagraphs).map((text, index) => (
              <div className={Style.policyLine} key={index}>
                {text.title && <h2 className={Style.lineTitle}>{t(text.title)}</h2>}

                {text.subtitle && (
                  <p
                    className={Style.lineText}
                    dangerouslySetInnerHTML={{
                      __html: t(text.subtitle),
                    }}
                  />
                )}

                {text.paragraphList && (
                  <ul
                    key={index}
                    className={Style.lineText}
                    dangerouslySetInnerHTML={{
                      __html: t(text.paragraphList),
                    }}
                  />
                )}

                {text.paragraph && (
                  <p
                    className={Style.lineText}
                    dangerouslySetInnerHTML={{
                      __html: t(text.paragraph),
                    }}
                  />
                )}
              </div>
            ))}
            <div className={Style.policyLine}>
              <p className={Style.lineText}>
                <Trans
                  i18nKey="kvkPage.kvk.downloadForm"
                  components={[
                    <a key={0} href={applicationForm} target="_blank" rel="noreferrer">
                      {0}
                    </a>,
                    <b key={1}>{1}</b>,
                  ]}
                />
              </p>
            </div>
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <SEO pageKey="kvkPolicy" />
      <PageHeader title={t('privacyPolicy')} />
      <div className={Style.section}>
        <Tabs tabs={tabs} defaultActiveKey="informationTabTitle" isKvkkPage />
      </div>
    </>
  );
};

export default KvkPolicy;
